import React, {useState, useEffect} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";import Loading from "../../core/Loading";
import {loadingAtom} from "../../atoms";
import {useRecoilState} from "recoil";
import ModalDiv from "../../ModalDiv";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import BackButton from "../common/BackButton";
import {formatDateToString, brazilianStates} from "../../utils/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const apiUrl = Config.apiUrl;

const AutomotiveServiceViewer = ({serviceId, onClose}) => {
    const [service, setService] = useState(null);
    const [loading, setLoading] = useRecoilState(loadingAtom);

    useEffect(() => {
        if (serviceId) {
            fetchService();
        }
    }, [serviceId]);

    const fetchService = async () => {
        try {
            setLoading(true);
            const url = apiUrl + '/api/automotiveservices/id=' + serviceId;
            const response = await makeRequest(url, 'GET');
            setService(response);
        } catch (error) {
            console.error('Error fetching automotive service:', error);
        } finally {
            setLoading(false);
        }
    };

    // Função para calcular o valor total baseado nos itens
    const calculateTotalValue = (items) => {
        if (!items || items.length === 0) return 0;
        return items.reduce((sum, item) => sum + (Number(item.value || 0) * Number(item.quantity || 0)), 0);
    };

    if (loading) {
        return <Loading/>;
    }

    if (!service) {
        return <div>Serviço não encontrado.</div>;
    }

    const getStatusLabel = (status) => {
        const statusMap = {
            'OPENING': 'Abertura',
            'PRODUCTION': 'Produção',
            'CONCLUDED': 'Concluído',
            'CANCELED': 'Cancelado'
        };
        return statusMap[status] || status;
    };

    const getStatusColor = (status) => {
        const colorMap = {
            'OPENING': '#ffa500', // laranja
            'PRODUCTION': '#0000ff', // azul
            'CONCLUDED': '#008000', // verde
            'CANCELED': '#ff0000' // vermelho
        };
        return colorMap[status] || '#000000';
    };

    const normalColor = 'var(--normal-green-color)';
    const attentionColor = 'var(--attention-color)';

    // Calcular o valor total baseado nos itens
    const calculatedTotalValue = calculateTotalValue(service.items);
    const receivables = Array.isArray(service.receivables) ? service.receivables : [];
    const discount = Number(service.discount || 0);
    const shipping = Number(service.shippingCost || 0);
    const storedTotal =
        service.totalValue != null && !Number.isNaN(Number(service.totalValue))
            ? Number(service.totalValue)
            : null;
    const computedNetTotal = Math.max(0, calculatedTotalValue + shipping - discount);
    const netTotal = storedTotal != null && storedTotal > 0 ? storedTotal : computedNetTotal;

    const paidFromReceivables = receivables
        .filter((r) => Number(r.status) === 1)
        .reduce((sum, r) => sum + Number(r.value || 0), 0);
    const pendingFromReceivables = receivables
        .filter((r) => Number(r.status) === 0)
        .reduce((sum, r) => sum + Number(r.value || 0), 0);
    const receivablesTotalSum = paidFromReceivables + pendingFromReceivables;

    const displayValorTotal = receivablesTotalSum > 0 ? receivablesTotalSum : netTotal;
    const displayPago = paidFromReceivables;
    let displayRestante = pendingFromReceivables;
    if (displayPago <= 0 && displayRestante <= 0) {
        displayRestante = netTotal;
    }

    const brl = (n) =>
        Number(n || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    const summaryRowStyle = {
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        width: '100%',
        textAlign: 'right',
    };

    return (
        <div>
            <div className="header-label">Serviço Automotivo - {service.code}</div>
            
            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Cliente:</div>
                    <input disabled="true" type="text" style={{width: '300px'}} value={service.customerName}
                           name="customerName"
                    />
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Telefone:</div>
                    <input disabled="true" type="text" style={{width: '300px'}} value={service.customerPhone}
                           name="customerPhone"
                    />
                </div>
            </div>

            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Carro:</div>
                    <input disabled="true" type="text" style={{width: '200px'}} value={service.car || ''}
                           name="car"
                    />
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Marca:</div>
                    <input disabled="true" type="text" style={{width: '200px'}} value={service.carBrand || ''}
                           name="carBrand"
                    />
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Placa:</div>
                    <input disabled="true" type="text" style={{width: '150px'}} value={service.licensePlate || ''}
                           name="licensePlate"
                    />
                </div>
            </div>

            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Quilometragem:</div>
                    <input disabled="true" type="number" style={{width: '150px'}} value={service.mileage || ''}
                           name="mileage"
                    />
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Ano do Modelo:</div>
                    <input disabled="true" type="number" style={{width: '150px'}} value={service.modelYear || ''}
                           name="modelYear"
                    />
                </div>
            </div>

            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Data do Serviço:</div>
                    <DatePicker
                        disabled={true}
                        className="datepicker"
                        selected={service.saleDate ? new Date(service.saleDate) : null}
                        dateFormat="dd/MM/yyyy"
                        autoComplete="off"
                    />
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Data de Entrega:</div>
                    <DatePicker
                        disabled={true}
                        className="datepicker"
                        selected={service.deliveryDate ? new Date(service.deliveryDate) : null}
                        dateFormat="dd/MM/yyyy"
                        autoComplete="off"
                    />
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Status:</div>
                    <select disabled="true" value={service.status}>
                        <option value="OPENING">Abertura</option>
                        <option value="PRODUCTION">Produção</option>
                        <option value="CONCLUDED">Concluído</option>
                        <option value="CANCELED">Cancelado</option>
                    </select>
                </div>
            </div>

            {/* Tabela de Itens */}
            <div>
                <table style={{width: '100%', marginTop: '10px', minHeight: '200px'}}>
                    <thead>
                        <tr>
                            <th style={{width: '200px'}}>Produto/Serviço</th>
                            <th style={{width: '100px'}}>Tipo</th>
                            <th style={{width: '80px'}}>Quantidade</th>
                            <th style={{width: '120px'}}>Valor (R$)</th>
                            <th style={{width: '120px'}}>Total (R$)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {service.items && service.items.length > 0 ? (
                            service.items.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <input disabled="true" type="text" style={{width: '300px'}} 
                                               value={item.product?.name || ''} />
                                    </td>
                                    <td>
                                        <input disabled="true" type="text" style={{width: '90px'}} 
                                               value={item.type || ''} />
                                    </td>
                                    <td>
                                        <input disabled="true" type="number" style={{width: '70px'}} 
                                               value={item.quantity || ''} />
                                    </td>
                                    <td>
                                        <input disabled="true" type="number" style={{width: '100px', textAlign: 'right'}} 
                                               value={item.value || ''} />
                                    </td>
                                    <td>
                                        <div style={{textAlign: 'right'}}>
                                            {(Number(item.quantity || 0) * Number(item.value || 0)).toLocaleString('pt-BR', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{textAlign: 'center', padding: '20px'}}>
                                    Nenhum item cadastrado
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {service.files && service.files.length > 0 && (
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Arquivos</div>
                    <ul style={{display: 'flex', flexDirection: 'column', padding: 0}}>
                        {service.files.map((file, index) => (
                            <li key={index}
                                style={{display: 'flex', alignItems: 'center', marginBottom: '8px', listStyle: 'none'}}>
                                <a href="" style={{cursor: "pointer"}} onClick={(e) => {
                                    e.preventDefault();
                                    // Implementar download de arquivo se necessário
                                }}>
                                    {file.displayFileName}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Formas de Pagamento */}
            {service.paymentMethods && service.paymentMethods.length > 0 && (
                <div style={{marginTop: '20px'}}>
                    <h3>Formas de Pagamento</h3>
                    <table style={{width: '100%', borderCollapse: 'collapse'}}>
                        <thead>
                        <tr style={{backgroundColor: '#f5f5f5'}}>
                            <th style={{border: '1px solid #ddd', padding: '8px', textAlign: 'left'}}>Forma de Pagamento</th>
                            <th style={{border: '1px solid #ddd', padding: '8px', textAlign: 'right'}}>Valor (R$)</th>
                            <th style={{border: '1px solid #ddd', padding: '8px', textAlign: 'center'}}>Vencimento</th>
                            <th style={{border: '1px solid #ddd', padding: '8px', textAlign: 'center'}}>Pago</th>
                        </tr>
                        </thead>
                        <tbody>
                        {service.paymentMethods.map((payment, index) => {
                            const dueDate = payment.dueDate ? formatDateToString(new Date(payment.dueDate)) : '-';
                            return (
                                <tr key={index}>
                                    <td style={{border: '1px solid #ddd', padding: '8px'}}>{payment.paymentMethod?.name || '-'}</td>
                                    <td style={{border: '1px solid #ddd', padding: '8px', textAlign: 'right'}}>
                                        R$ {(payment.value || 0).toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                    </td>
                                    <td style={{border: '1px solid #ddd', padding: '8px', textAlign: 'center'}}>{dueDate}</td>
                                    <td style={{border: '1px solid #ddd', padding: '8px', textAlign: 'center'}}>
                                        {payment.paid ? 'Sim' : 'Não'}
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            )}

            <div className="total-label"
                 style={{...summaryRowStyle, color: attentionColor}}>
                Desconto: R$ {brl(discount)}
            </div>
            <div className="total-label" style={summaryRowStyle}>
                Valor Total: R$ {brl(displayValorTotal)}
            </div>
            <div className="total-label"
                 style={{...summaryRowStyle, color: normalColor}}>
                Pago: R$ {brl(displayPago)}
            </div>
            <div className="total-label"
                 style={{...summaryRowStyle, color: attentionColor}}>
                Restante: R$ {brl(displayRestante)}
            </div>

            <ActionButtonsManagerView>
                <BackButton onClick={onClose}/>
            </ActionButtonsManagerView>
        </div>
    );
};

export default AutomotiveServiceViewer; 